import React, { useState, useEffect } from 'react';
var MountedContext = React.createContext();

function MountedProvider(_ref) {
  var children = _ref.children;

  var _useState = useState(false),
      isMounted = _useState[0],
      setMounted = _useState[1];

  useEffect(function () {
    setMounted(true);
  }, []);
  return React.createElement(MountedContext.Provider, {
    value: isMounted
  }, children);
}

MountedProvider.Context = MountedContext;
MountedProvider.Consumer = MountedContext.Consumer;
export default MountedProvider;